/** @format */

import add from "../../../assets/images/Add.svg";
import Delete from "../../../assets/images/Remove.png";
import Edit from "../../../assets/images/Edit.svg";
import star from "../../../assets/images/Star Filled.svg";
import { useEffect, useState } from "react";
import { AddLinkModal } from "../addlinkmodal";
import { EditLinkModal } from "../editlinkmodal";
import {
  Container,
  Heading,
  AddContainer,
  Add,
  LinkContainer,
  Link,
  LinkDelete,
  LinkDeleteIcon,
  LinkImage,
  Group1,
  NameAndLink,
  LinkName,
  LinkUrl,
  LinkStar,
  StarIcon,
  Group2,
  LinkClicks,
  LinkEdit,
  LinkEditIcon,
} from "./styles";
import axios from "axios";
import { API_URL } from "../../../constants";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const LinkTab = () => {
  const [edit, setEdit] = useState({
    isAddActive: false,
    isEditActive: false,
  });
  const [links, setLinks] = useState<any>([]);
  const [linkData, setLinkData] = useState<any>();
  let businessUuid = useSelector((state: any) => state.auth.uuid);

  const toggleClear = () => {
    setEdit({
      isAddActive: false,
      isEditActive: false,
    });
  };
  const toggleEdit = () => {
    setEdit({
      isAddActive: false,
      isEditActive: true,
    });
  };
  const toggleAdd = () => {
    setEdit({
      isAddActive: true,
      isEditActive: false,
    });
  };

  const getLink = () => {
    axios.get(`${API_URL}/links/${businessUuid}`).then((response) => {
      setLinks(response.data.data);
    });
  };

  useEffect(() => {
    getLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const deleteLink = (id: any) => {
    axios.delete(`${API_URL}/delete/link/${id}`).then((response) => {
      if (response.status === 200 || response.status === 201) {
        getLink();
        toast.success(response.data.message);
      }
    });
  };

  return (
    <>
      <Container>
        <Heading>My Links</Heading>
        <AddContainer onClick={toggleAdd}>
          <h2>Add New Link</h2>
          <Add>
            <img src={add} alt="" />
          </Add>
        </AddContainer>
        <LinkContainer>
          {links?.map((link: any) => (
            <Link key={link.id}>
              <LinkDelete>
                <LinkDeleteIcon
                  onClick={() => {
                    deleteLink(link.id);
                  }}
                >
                  <img src={Delete} alt="" />
                </LinkDeleteIcon>
              </LinkDelete>
              {link?.image ? (
                <LinkImage>
                  <img src={link?.image} alt="" />
                </LinkImage>
              ) : null}
              <Group1>
                <NameAndLink>
                  <LinkName>
                    <h2>{link.name === "null" ? "" : link.name}</h2>
                  </LinkName>
                  <LinkUrl>
                    <p>{link.url}</p>
                  </LinkUrl>
                </NameAndLink>
                <LinkStar>
                  {link.isImportant ? (
                    <StarIcon>
                      <img src={star} alt="" />
                    </StarIcon>
                  ) : null}
                </LinkStar>
                <Group2>
                  <LinkClicks>
                    <span>{link.clicks} </span> <p>Clicks</p>
                  </LinkClicks>

                  <LinkEdit
                    onClick={() => {
                      setLinkData(link);
                    }}
                  >
                    <LinkEditIcon onClick={toggleEdit}>
                      <img src={Edit} alt="" />
                    </LinkEditIcon>
                  </LinkEdit>
                </Group2>
              </Group1>
            </Link>
          ))}
        </LinkContainer>
      </Container>
      {edit.isEditActive ? <EditLinkModal toggleClear={toggleClear} getLink={getLink} linkData={linkData} /> : null}
      {edit.isAddActive ? <AddLinkModal toggleClear={toggleClear} getLink={getLink} /> : null}
    </>
  );
};

export default LinkTab;
